import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=52528f00&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52528f00",
  null
  
)

export default component.exports